<template>
    <section class="c-reviews" :class="[background, spaces]">
        <div class="c-container">
            <div class="c-reviews__headline c-headline psb-30 psb-md-60">
                <h2 class="headline" v-html="nl2br(data.title)"></h2>
                <div v-show="isDesktop" class="slider__navigation">
                    <button class="custom-nav-prev-slide c__reviews__prev">
                        <span class="icon">
                            <SvgsArrowSLeft :fill="'#ffffff'" />
                        </span>
                    </button>
                    <button class="custom-nav-next-slide c__reviews__next">
                        <span class="icon">
                            <SvgsArrowSRight :fill="'#ffffff'" />
                        </span>
                    </button>
                </div>
            </div>
        </div>
        <div class="c-container left">
            <CarouselReview :reviews="data.reviews" />
        </div>
    </section>
</template>

<script setup>
    const props = defineProps({
        data: {
            type: Object,
            default: {}
        },
        background: {
            type: String,
            default: "bg-white"
        },
        spaces: {
            type: String,
            default: "pst-100 psb-100 pst-md-150 psb-md-150"
        }
    });

    const isDesktop = useMediaQuery("(min-width: 1181px)");
</script>
